import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { ModelRetirementConfig } from '../services/api/commonData';

interface ModelRetirementBannerProps {
    retirementConfig: ModelRetirementConfig;
    onUpgrade: (replacementModel: string) => void;
    onDismiss: () => void;
    isUpgrading?: boolean;
}

const ModelRetirementBanner: React.FC<ModelRetirementBannerProps> = ({
    retirementConfig,
    onUpgrade,
    onDismiss,
    isUpgrading = false
}) => {
    const isDeprecated = retirementConfig.status === 'deprecated';
    const bgColor = isDeprecated ? 'bg-red-50 border-red-200' : 'bg-yellow-50 border-yellow-200';
    const textColor = isDeprecated ? 'text-red-800' : 'text-yellow-800';
    const iconColor = isDeprecated ? 'text-red-500' : 'text-yellow-500';
    const buttonBg = isDeprecated ? 'bg-red-600 hover:bg-red-700' : 'bg-yellow-600 hover:bg-yellow-700';

    return (
        <div className={`${bgColor} border rounded-lg px-4 py-3 mb-4 flex items-center justify-between`}>
            <div className="flex items-center gap-3 flex-1">
                <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className={`${iconColor} text-lg`}
                />
                <div className="flex-1">
                    <span className={`${textColor} font-medium`}>
                        {retirementConfig.message}
                    </span>
                    {retirementConfig.retirement_date && (
                        <span className={`${textColor} text-sm ml-2`}>
                            (Retirement date: {new Date(retirementConfig.retirement_date).toLocaleDateString()})
                        </span>
                    )}
                </div>
            </div>
            <div className="flex items-center gap-2 ml-4">
                <button
                    onClick={() => onUpgrade(retirementConfig.replacement_model)}
                    disabled={isUpgrading}
                    className={`${buttonBg} text-white px-4 py-1.5 rounded-md text-sm font-medium flex items-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                    {isUpgrading ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            Upgrading...
                        </>
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faArrowUp} />
                            Upgrade to {retirementConfig.replacement_model}
                        </>
                    )}
                </button>
                <button
                    onClick={onDismiss}
                    className={`${textColor} hover:opacity-70 p-1.5 rounded transition-opacity`}
                    title="Dismiss"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

export default ModelRetirementBanner;
